import type { useForm } from "hooks";
import type { CustomFile } from "lib/upload";
import type { Moment } from "moment";
import type { BootstrapableForm } from "types";

export const enum FormField {
    SettlementDate = 'settlementDate',
    Mor = 'MOR',
    Psp = 'PSP',
    CsvSeparator = 'csvSeparator',
    File = 'file'
};

export type UploadSettlement = {
    readonly [FormField.SettlementDate]: Moment | string | null;
    readonly [FormField.Mor]: string | null;
    readonly [FormField.Psp]: string | null;
    readonly [FormField.CsvSeparator]: string;
    readonly [FormField.File]: CustomFile | null;
};

export type UploadSettlementBootstrapData = {
    readonly [FormField.CsvSeparator]: Array<string>;
};

export type UploadSettlementForm = Omit<
    BootstrapableForm<UploadSettlement, UploadSettlementBootstrapData>,
    | 'initialValues'
> & {
    readonly initialValues: UploadSettlement;
};

export type UploadSettlementProps =
    & UploadSettlementForm
    & ReturnType<typeof useForm<UploadSettlement>>;
